import { JsonUtils } from '../../utils/json.util'
import { TypesNodules } from './followUp'

export class Anamnese {

    // Anamnesis 
    private _birth_control: string | undefined
    private _alcohol: string | undefined
    private _obesity: string | undefined
    private _smoker: string | undefined
    private _smoker_time: number | null | undefined
    private _family_history_cancer: string | undefined
    private _degree_of_kinship: number | undefined
    private _age_first_pregnancy: number | undefined
    private _pregnancy_quantity: number | undefined
    private _lactation_time: number | undefined
    private _menarche_age: number | undefined
    private _menopause_age: number | undefined
    private _hormonal_replace_type: number | undefined
    private _nodule_presence: string | undefined
    private _nodule_type: string | undefined
    private _mammary_pain: string | undefined
    private _pain_edema_hyperemia: string | undefined
    private _serosanguineous_discharge: string | undefined
    private _papillary_discharge: string | undefined
    private _multicolor_discharge: string | undefined
    private _armpit: string | undefined
    private _supraclavicular_fossa: string | undefined
    private _nipple_retraction: string | undefined
    private _derm_retraction: string | undefined
    private _breast_fistula: string | undefined

    constructor() {
        this._nodule_type = TypesNodules.NOT_CONTAIN.toLowerCase()
       // this._smoker_time = 0
    }

    // Anamnesis data
    get birth_control(): string | undefined {
        return this._birth_control
    }
    set birth_control(value: string | undefined) {
        this._birth_control = value
    }
    get alcohol(): string | undefined {
        return this._alcohol
    }
    set alcohol(value: string | undefined) {
        this._alcohol = value
    }
    get obesity(): string | undefined {
        return this._obesity
    }
    set obesity(value: string | undefined) {
        this._obesity = value
    }
    get smoker(): string | undefined {
        return this._smoker
    }
    set smoker(value: string | undefined) {
        this._smoker = value
    }
    get smoker_time(): number | null | undefined {
        return this._smoker_time
    }
    set smoker_time(value: number | null | undefined) {
        this._smoker_time = value
    }
    get family_history_cancer(): string | undefined {
        return this._family_history_cancer
    }
    set family_history_cancer(value: string | undefined) {
        this._family_history_cancer = value
    }
    get age_first_pregnancy(): number | undefined {
        return this._age_first_pregnancy
    }
    set age_first_pregnancy(value: number | undefined) {
        this._age_first_pregnancy = value
    }
    get pregnancy_quantity(): number | undefined {
        return this._pregnancy_quantity
    }
    set pregnancy_quantity(value: number | undefined) {
        this._pregnancy_quantity = value
    }
    get lactation_time(): number | undefined {
        return this._lactation_time
    }
    set lactation_time(value: number | undefined) {
        this._lactation_time = value
    }
    get menarche_age(): number | undefined {
        return this._menarche_age
    }
    set menarche_age(value: number | undefined) {
        this._menarche_age = value
    }
    get menopause_age(): number | undefined {
        return this._menopause_age
    }
    set menopause_age(value: number | undefined) {
        this._menopause_age = value
    }
    get hormonal_replace_type(): number | undefined {
        return this._hormonal_replace_type
    }
    set hormonal_replace_type(value: number | undefined) {
        this._hormonal_replace_type = value
    }
    get nodule_presence(): string | undefined {
        return this._nodule_presence
    }

    set nodule_presence(value: string | undefined) {
        this._nodule_presence = value
    }
    get nodule_type(): string | undefined {
        return this._nodule_type
    }

    set nodule_type(value: string | undefined) {
        this._nodule_type = value
    }
    get mammary_pain(): string | undefined {
        return this._mammary_pain
    }

    set mammary_pain(value: string | undefined) {
        this._mammary_pain = value
    }
    get pain_edema_hyperemia(): string | undefined {
        return this._pain_edema_hyperemia
    }

    set pain_edema_hyperemia(value: string | undefined) {
        this._pain_edema_hyperemia = value
    }
    get serosanguineous_discharge(): string | undefined {
        return this._serosanguineous_discharge
    }

    set serosanguineous_discharge(value: string | undefined) {
        this._serosanguineous_discharge = value
    }
    get papillary_discharge(): string | undefined {
        return this._papillary_discharge
    }

    set papillary_discharge(value: string | undefined) {
        this._papillary_discharge = value
    }
    get multicolor_discharge(): string | undefined {
        return this._multicolor_discharge
    }

    set multicolor_discharge(value: string | undefined) {
        this._multicolor_discharge = value
    }
    get armpit(): string | undefined {
        return this._armpit
    }

    set armpit(value: string | undefined) {
        this._armpit = value
    }
    get supraclavicular_fossa(): string | undefined {
        return this._supraclavicular_fossa
    }

    set supraclavicular_fossa(value: string | undefined) {
        this._supraclavicular_fossa = value
    }
    get nipple_retraction(): string | undefined {
        return this._nipple_retraction
    }

    set nipple_retraction(value: string | undefined) {
        this._nipple_retraction = value
    }
    get derm_retraction(): string | undefined {
        return this._derm_retraction
    }

    set derm_retraction(value: string | undefined) {
        this._derm_retraction = value
    }

    get breast_fistula(): string | undefined {
        return this._breast_fistula
    }

    set breast_fistula(value: string | undefined) {
        this._breast_fistula = value
    }
    get degree_of_kinship(): number | undefined {
        return this._degree_of_kinship
    }

    set degree_of_kinship(value: number | undefined) {
        this._degree_of_kinship = value
    }

    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Anamnese {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        // Anamnese
        if (json.birth_control !== undefined) {
            this.birth_control = `${json.birth_control}`
        }
        if (json.alcohol !== undefined) {
            this.alcohol = `${json.alcohol}`
        }
        if (json.obesity !== undefined) {
            this.obesity = `${json.obesity}`
        }
        if (json.smoker !== undefined) {
            this.smoker = `${json.smoker}`
        }
        if (json.smoker_time !== undefined) {
            this.smoker_time = json.smoker_time
        }
        if (json.family_history_cancer !== undefined) {
            this.family_history_cancer = `${json.family_history_cancer}`
        }
        if (json.age_first_pregnancy !== undefined) {
            this.age_first_pregnancy = json.age_first_pregnancy
        }
        if (json.pregnancy_quantity !== undefined) {
            this.pregnancy_quantity = json.pregnancy_quantity
        }
        if (json.lactation_time !== undefined) {
            this.lactation_time = json.lactation_time
        }
        if (json.menarche_age !== undefined) {
            this.menarche_age = json.menarche_age
        }
        if (json.menopause_age !== undefined) {
            this.menopause_age = json.menopause_age
        }
        if (json.hormonal_replace_type !== undefined) {
            this.hormonal_replace_type = json.hormonal_replace_type
        }
        if (json.nodule_presence !== undefined) {
            this.nodule_presence = `${json.nodule_presence}`
        }
        if (json.nodule_type !== undefined) {
            this.nodule_type = json.nodule_type
        }
        if (json.mammary_pain !== undefined) {
            this.mammary_pain = `${json.mammary_pain}`
        }
        if (json.pain_edema_hyperemia !== undefined) {
            this.pain_edema_hyperemia = `${json.pain_edema_hyperemia}`
        }
        if (json.serosanguineous_discharge !== undefined) {
            this.serosanguineous_discharge = `${json.serosanguineous_discharge}`
        }
        if (json.papillary_discharge !== undefined) {
            this.papillary_discharge = `${json.papillary_discharge}`
        }
        if (json.multicolor_discharge !== undefined) {
            this.multicolor_discharge = json.multicolor_discharge
        }
        if (json.armpit !== undefined) {
            this.armpit = `${json.armpit}`
        }
        if (json.supraclavicular_fossa !== undefined) {
            this.supraclavicular_fossa = `${json.supraclavicular_fossa}`
        }
        if (json.nipple_retraction !== undefined) {
            this.nipple_retraction = `${json.nipple_retraction}`

        }
        if (json.derm_retraction !== undefined) {
            this.derm_retraction = `${json.derm_retraction}`
        }
        if (json.breast_fistula !== undefined) {
            this.breast_fistula = `${json.breast_fistula}`
        }
        if (json.degree_of_kinship !== undefined) {
            this.degree_of_kinship = json.degree_of_kinship
        }
        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            // Anamnese
            alcohol: this.alcohol ? this.alcohol === "true" : undefined,
            birth_control: this.birth_control ? this.birth_control === "true" : undefined,
            obesity: this.obesity ? this.obesity === "true" : undefined,
            smoker: this.smoker ? this.smoker === "true" : undefined,
            smoker_time:this.smoker_time !== undefined ? this.smoker_time : undefined/* this.smoker_time || undefined*/,
            family_history_cancer: this.family_history_cancer ? this.family_history_cancer === "true" : undefined,
            degree_of_kinship: this.degree_of_kinship !== undefined ? this.degree_of_kinship : undefined,
            age_first_pregnancy: this.age_first_pregnancy !== undefined ? this.age_first_pregnancy : undefined,
            pregnancy_quantity: this.pregnancy_quantity !== undefined ? this.pregnancy_quantity : undefined,
            lactation_time: this.lactation_time !== undefined ? this.lactation_time : undefined,
            menarche_age: this.menarche_age !== undefined ? this.menarche_age : undefined,
            menopause_age: this.menopause_age !== undefined ? this.menopause_age : undefined,
            hormonal_replace_type: this.hormonal_replace_type !== undefined ? this.hormonal_replace_type : undefined,
            nodule_presence: this.nodule_presence ? this.nodule_presence === "true" : undefined,
            nodule_type: this.nodule_type !== TypesNodules.NOT_CONTAIN.toLowerCase() ? this.nodule_type : undefined,
            mammary_pain: this.mammary_pain ? this.mammary_pain === "true" : undefined,
            pain_edema_hyperemia: this.pain_edema_hyperemia ? this.pain_edema_hyperemia === "true" : undefined,
            serosanguineous_discharge: this.serosanguineous_discharge ? this.serosanguineous_discharge === "true" : undefined,
            papillary_discharge: this.papillary_discharge ? this.papillary_discharge === "true" : undefined,
            multicolor_discharge: this.multicolor_discharge || undefined,
            armpit: this.armpit ? this.armpit === "true" : undefined,
            supraclavicular_fossa: this.supraclavicular_fossa ? this.supraclavicular_fossa === "true" : undefined,
            nipple_retraction: this.nipple_retraction ? this.nipple_retraction === "true" : undefined,
            derm_retraction: this.derm_retraction ? this.derm_retraction === "true" : undefined,
            breast_fistula: this.breast_fistula ? this.breast_fistula === "true" : undefined,
        }
    }
}